(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6890],{

/***/ 22871:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms",
      function () {
        return __webpack_require__(74410);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33838);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);



const Link = (param)=>{
    let { href , color ="secondary" , onClick , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
        as: (next_link__WEBPACK_IMPORTED_MODULE_1___default()),
        href: href || "#",
        passHref: true,
        color: color,
        onClick: onClick ? (e)=>{
            e.preventDefault();
            onClick(e);
        } : undefined,
        ...props,
        children: children
    });
};
Link.displayName = "Link";


/***/ }),

/***/ 49441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36979);


const Container = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W, {
        ...props,
        children: children
    });
};
Container.displayName = "Container";


/***/ }),

/***/ 91003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95034);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88911);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24804);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(204);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36953);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66303);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46887);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40989);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53854);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20956);
/* harmony import */ var _components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41151);







const Header = (param)=>{
    let { title , ...props } = param;
    const left = title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderLogo, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Spacer */ .L, {});
    const center = title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
        textAlign: "center",
        color: "white",
        children: title
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderLogoHorizontal, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .U, {
        h: "50px",
        position: "sticky",
        top: 0,
        left: 0,
        right: 0,
        bg: "base",
        paddingX: 4,
        justifyContent: "space-between",
        alignItems: "center",
        zIndex: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .k, {
                flexBasis: "50px",
                justifyContent: "flex-start",
                children: left
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .k, {
                flex: 1,
                justifyContent: "center",
                children: center
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .k, {
                flexBasis: "50px",
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderMenu, {})
            })
        ]
    });
};
const HeaderLogo = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .r, {
        href: "/",
        lineHeight: 1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: "/images/logoWhite.png",
            width: 32,
            height: 32,
            alt: "トレーニングシェア"
        })
    });
};
const HeaderLogoHorizontal = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .r, {
        href: "/",
        lineHeight: 1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: "/images/logoHorizontal.png",
            width: 142,
            height: 32,
            alt: "トレーニングシェア"
        })
    });
};
const HeaderMenu = ()=>{
    const { isAuthenticated , isActionRequired  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const isGuest = !isAuthenticated && !isActionRequired;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Menu */ .v, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .MenuButton */ .j, {
                "aria-label": "メニュー",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_11__/* .HiMenu */ .r0I, {
                    color: "white",
                    size: 28
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .MenuList */ .q, {
                children: [
                    isGuest && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/"),
                                children: "トップページ"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/signup"),
                                children: "メールアドレスで登録"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/signin"),
                                children: "ログイン"
                            })
                        ]
                    }),
                    isAuthenticated && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/top?howToUse=open"),
                                children: "トレーニングシェアとは"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/news"),
                                children: "新着情報一覧"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/glossary"),
                                children: "用語集"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/profile"),
                                children: "プロフィール編集"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/credit_card"),
                                children: "クレジットカード変更"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                        onClick: ()=>router.push("/contact"),
                        children: "お問い合わせ"
                    }),
                    !isGuest && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                        onClick: ()=>router.push("/signout"),
                        children: "ログアウト"
                    })
                ]
            })
        ]
    });
};
Header.displayName = "Header";


/***/ }),

/***/ 45564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SubHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23100);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24804);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88911);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8193);
/* harmony import */ var _components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41151);





const SubHeader = (param)=>{
    let { backTo  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const handleClick = ()=>{
        if (window.history.length <= 1) {
            router.push(backTo);
        } else {
            router.back();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        paddingY: 4,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
            onClick: handleClick,
            color: "textDark",
            display: "inline-block",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .U, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_5__/* .AiOutlineArrowLeft */ .kyg, {
                        size: 22
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                        fontSize: "sm",
                        children: "戻る"
                    })
                ]
            })
        })
    });
};
SubHeader.displayName = "SubHeader";


/***/ }),

/***/ 85782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23100);


const Wrapper = (param)=>{
    let { header , footer , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        children: [
            header,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                pb: footer ? 20 : 4,
                children: children
            }),
            footer
        ]
    });
};
Wrapper.displayName = "Wrapper";


/***/ }),

/***/ 96981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Title; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


const Title = (param)=>{
    let { title , override =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: "\n          ".concat(title, "\n          ").concat(override ? "" : "｜トレーニングシェア", "\n        ")
        })
    });
};


/***/ }),

/***/ 74410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ terms; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-QLVBORJB.mjs
var chunk_QLVBORJB = __webpack_require__(90634);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-P74GIWPW.mjs
var chunk_P74GIWPW = __webpack_require__(88911);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-Z47J5YMH.mjs
var chunk_Z47J5YMH = __webpack_require__(5197);
// EXTERNAL MODULE: ./components/layouts/Container/Container.tsx
var Container = __webpack_require__(49441);
// EXTERNAL MODULE: ./components/layouts/Header/Header.tsx
var Header = __webpack_require__(91003);
// EXTERNAL MODULE: ./components/layouts/SubHeader/SubHeader.tsx
var SubHeader = __webpack_require__(45564);
// EXTERNAL MODULE: ./components/layouts/Wrapper/Wrapper.tsx
var Wrapper = __webpack_require__(85782);
// EXTERNAL MODULE: ./components/metas/Title/Title.tsx
var Title = __webpack_require__(96981);
;// CONCATENATED MODULE: ./components/pages/TermsPage.tsx







const TermsPage = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper/* Wrapper */.i, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
            title: "利用規約"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                title: "利用規約"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeader/* SubHeader */.b, {
                        backTo: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_QLVBORJB/* VStack */.g, {
                        spacing: 6,
                        my: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                fontWeight: "bold",
                                fontSize: "lg",
                                children: "利用規約"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_QLVBORJB/* VStack */.g, {
                                spacing: 4,
                                alignItems: "stretch",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: "この利用規約（以下「本規約」といいます）は、株式会社IMPRINT(以下「当社」といいます)が運営する「トレーニングシェア」の利用に関する条件を、本サービスを利用する法人、団体、組合又は個人と、当社との間で定めるものです。"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第1条 定義"
                                            }),
                                            "本規約において使用する用語を以下の通り定めます。",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* OrderedList */.GS, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "「会員」とは、本サービスを利用する全ての個人または法人を指します。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "「本サービス」とは、当社が利用者に提供する「トレーニングシェア」に関する全てのサービスをいいます。本サービスの詳細は、当社が別途定めるところによります。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "「コンテンツ」とは、当社が本サービス上に掲載する文章、表、画像・写真、イラスト、アイコン、キャラクター、ロゴ等の一切の情報を指します。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "「アカウント」とは、本サービスに関して当社が定める利用単位を指します。"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第2条 本規約への同意"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* OrderedList */.GS, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "会員は、本規約の定めに従って本サービスを利用しなければならず、本サービスを実際に利用することにより、本規約に有効かつ取消不能な同意をしたものとみなされます。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "本サービスにおいて当社が掲載した注意事項等についても本規約の一部を構成するものとし、会員はこれらについても遵守しなければなりません。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "会員が未成年の場合、予め親権者の承諾を得た上で、本サービスを利用するものとします。"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第3条 本規約の変更"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* OrderedList */.GS, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "当社は、当社が必要と認めた場合に、本規約の内容を変更することができるものとします。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "本規約を変更する場合、当社は、当社Webサイトへの掲示その他当社が適当と判断した方法により、あらかじめ変更後の本規約の内容及び効力発生時期を通知します。ただし、法令上会員の同意が必要となる変更を行う場合は、当社が適当と判断した方法により同意を得るものとします。なお、会員が効力発生日以後に本サービスを利用した場合には、法令上その効力を否定される場合を除き、変更後の本規約に同意したものとみなされます。"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第4条 本サービス利用環境の設定"
                                            }),
                                            "会員は、本サービスの利用にあたっては、自らの責任と負担において、その利用に必要となるハードウェア、ソフトウェア及びインターネット接続環境等、本サービスを利用するために必要となる一切の環境を設定し、整備するものとします。なお、ここにいう環境の設定と整備には、本サービスの品質を維持するために必要となるソフトウェアの更新を行うことを含みます。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第5条 利用料金"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* OrderedList */.GS, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "会員は、利用するアカウントの数に応じ、本サービスの利用料金（以下「利用料金」といいます）として当社Webサイト等に別途掲載する金額を、当社所定の方法により、当社に対して支払うものとします。なお、利用料金の日割り計算は一切行われません。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "当社は、いかなる理由があっても既に支払われた利用料金は一切返還しません。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "会員は、本サービス利用の停止を行う場合、当社所定の期限までに、当社所定の方法により解約申請手続きを行う必要があります。会員が当該手続を完了しない限り、本サービスの利用期間は1ヶ月間自動で更新されるものとします。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "会員が当社所定の期限までに利用料金をお支払いいただけない場合、年12%の割合による遅延損害金をお支払い頂くものとします。"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第6条 ID等の取扱い"
                                            }),
                                            "当社から会員に対してIDおよびパスワード等が付与された場合、会員はこれらのIDおよびパスワード等を第三者に開示・漏洩することのないよう必要かつ十分な注意義務をもって取り扱うものとし、IDおよびパスワードの管理不十分、使用上の過誤、第三者使用等による損害は、会員が負うものとします。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第7条 知的財産権の帰属等"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* OrderedList */.GS, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "本サービスおよびコンテンツに関する著作権及びその他の知的財産権は、すべて当社又は正当な権利を有する第三者に帰属するものとし、会員には帰属致しません。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "本サービスおよびコンテンツの一切につき、会員は無断で複製、譲渡、貸与、翻訳、改変、転載、公衆送信（送信可能化を含みます。）、伝送、配布、販売､提供､出版、営業使用等を行ってはなりません｡"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第8条 禁止事項"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* OrderedList */.GS, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: [
                                                            "会員は、本サービスの利用において以下の各号に定める行為をしてはならないものとします。",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* List */.aV, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(1) 利用料金を支払期日までに支払わないこと"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(2) 1つのアカウントを第三者に対して利用させもしくは貸与し、または第三者との間で共有すること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(3) 法令、裁判所の判決、決定もしくは命令、または法令上拘束力のある行政措置への違反"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(4) 公の秩序または善良の良俗を害すること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(5) 反社会的勢力に対する利益供与その他の協力をすること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(6) 犯罪による収益の移転行為およびこれを助長、幇助等すること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(7) 第三者へのなりすましまたは意図的に虚偽の情報を送信すること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(8) 当社、他の会員、その他第三者の権利を侵害し、または迷惑をかけること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(9) 不正アクセス行為、またはこれを助長する行為"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(10) 本サービスの誤作動を誘引すること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(11) 本サービスが通常意図しないバグを利用する動作を生じさせ、または、通常意図しない効果を及ぼす外部ツールの利用、作成、または頒布"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(12) 当社、他の会員のサーバー、コンピュータ等に過度の負担をかけること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(13) 当社、他の会員、その他第三者にコンピュータウイルス等の有害なプログラムを送信し、または流布すること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(14) 本サービスの運営を妨げること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(15) 不正な目的をもって、本サービスを利用すること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(16) 本規約に違反し、または、本サービスの趣旨目的に反すること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(17) その他当社が不適切と判断すること"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: [
                                                            "会員が前項の定めに違反した場合、当社は会員に事前に通知することなく、以下の各項に定める措置の一部または全部を講じることができます。",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* List */.aV, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(1) 会員による本サービスの利用を中止、停止、会員資格のはく奪をすること"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                                        children: "(2) 会員に対し、会員が不当に得た利益に相当する金額の返還請求をすること"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "前項の措置を講じたことによって会員に生じた損害については、当社は一切責任を負いません。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "会員が第１項を含む本規約のいずれかの規定に違反したことにより当社に損害が生じた場合、会員は、当社に対し、当社に生じた全ての損害を賠償しなければならないものとします。"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第9条 譲渡禁止"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* OrderedList */.GS, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "会員は、本サービスまたはアカウントの利用にかかる権利義務を第三者に譲渡、貸与してはなりません。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "当社が本サービスに関する事業を第三者に譲渡した場合には、当該事業譲渡に伴い、本規約に基づく権利及び義務並び会員の登録事項その他の会員に関する情報を当該事業譲渡の譲受人に譲渡することができるものとし、会員は、係る譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他の事業が移転するあらゆる場合を含むものとします。"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第10条 免責"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* OrderedList */.GS, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "本規約における当社の責任は合理的な努力をもって本サービスを運営することに限られるものとし、当社は本サービスの正確性、最新性、有用性、信頼性、適法性、特定目的への適合性、第三者の権利を侵害していないことを含め一切責任を負わず、またいかなる保証もなされません。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "本サービスにおいて提供するコンテンツは、可能な限り安全面に留意しておりますが、会員は、自己の責任において体調管理を行うと共に安全面に配慮し、トレーニングを行っていただくものとします。本サービスは、コンテンツの提供を目的とするものであり、当社は、会員において実施したトレーニングの結果や事故等について、責任を負いません。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "本サービスに関連して会員と会員の顧客等を含む第三者との間で生じるトラブル、その他の事項に対して、当社はいかなる責任を負わず、補償を行いません。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "当社は、当社のウェブページ・サーバ・ドメインなどから送られるメール・コンテンツに、コンピュータウイルスなどの有害なものが含まれていないことを保証しません。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "天災地変、戦争、テロ、暴動、法令・規則の制定改廃、政府機関の介入または命令、伝染病、停電、通信回線やコンピュータ等の障害・システムメンテナンス等による中断・遅滞・中止・データの消失、データの不正アクセス、輸送機関の事故、労働争議、設備の事故等の不可抗力等により、本サービスの一部または全部が停止する場合に会員に生じた損害について、当社は一切責任を負いません。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "会員が本規約に違反したことによって生じた損害については、当社は一切責任を負いません。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "本規約に定める免責条項が適用されない等の理由により当社が会員に対して責任を負うべき場合、当社に故意又は重過失がある場合を除き、それらの責任に基づく当社の損害賠償額は、会員が本サービスを利用するにあたって当社に対して支払った3か月分の利用料金に相当する金額（但し当該会員が支払った利用料金の金額がこれに満たない場合には会員が実際に支払った利用料金の合計金額とします。）を上限額とします。また、当社は、当社に故意又は重過失がある場合を除き、付随的損害、間接損害、特別損害、将来の損害及び逸失利益にかかる損害については、賠償する責任を負わないものとします。"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第11条 サービスの停止・終了"
                                            }),
                                            "当社は、事前に1ヶ月前までに会員に対して通知することにより、特定の会員または全ての会員に対して、本サービスまたは本サービスに付帯するサービスの提供を停止・終了することができるものとします。当社は、本サービスの停止・終了によって会員に生じた損害または不利益に対して一切責任を負いません。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第12条 暴力団等の反社会的勢力の排除"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z47J5YMH/* OrderedList */.GS, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "当社及び会員は、本サービスの利用又は提供に際して、自身が暴力団、暴力団員、暴力団関係企業、総会屋、社会運動標ぼうゴロ、政治運動標ぼうゴロ、特殊知能暴力集団、その他反社会的勢力（以下｢暴力団等反社会的勢力｣といいます。）に所属又は該当せず、かつ、暴力団等反社会的勢力と関与していないことを表明し、将来にわたっても所属若しくは該当、又は関与しないことを確約するものとします。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "当社は、会員が暴力団等反社会的勢力に所属若しくは該当する、又は関与していると判断した場合、事前に通知等を行うことなく、利用サービスの使用停止の措置、利用契約の解除をすることができます。会員は、当社が暴力団等反社会的勢力に所属若しくは該当する、又は関与していると判断した場合、事前に通知等を行うことなく、利用契約の解除をすることができます。"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_Z47J5YMH/* ListItem */.HC, {
                                                        children: "前項による解除の場合、解除をした当事者は相手方に対して解除による損害を賠償する義務を負いません。"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第13条 通知"
                                            }),
                                            "本サービスに関する当社から会員への通知等は、会員登録頂いたメールアドレス宛てへのメールの送信、ウェブサイト上への掲示、または、その他当社が適当と判断する方法によって行います。会員は、当社がこれらの通知等を行ってから24時間後に、当社からの通知が到達したとみなされることに、予め同意するものとします。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第14条 連絡・宣伝"
                                            }),
                                            "当社は、会員に対して、本サービスに関するヒアリング等するために、電話またはメールその他の方法により、ご連絡する場合がございます。当社は、会員に対して、法令等を遵守した上で、本サービスに関するキャンペーン告知、広告宣伝等のために、電話、メール、郵便その他の方法により、ご連絡する場合があります。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "第15条 準拠法・管轄裁判所"
                                            }),
                                            "本規約は日本法に基づき解釈されるものとし、本規約に関し訴訟の必要が生じた場合には、訴額に応じ、東京簡易裁判所または東京地方裁判所を第一審の専属的合意管轄裁判所といたします。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: "本規約は 2022 年 8月21日から適用します。"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_TermsPage = (TermsPage);

;// CONCATENATED MODULE: ./pages/terms.tsx


const Terms = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_TermsPage, {});
};
/* harmony default export */ var terms = (Terms);


/***/ }),

/***/ 5197:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GS": function() { return /* binding */ OrderedList; },
/* harmony export */   "HC": function() { return /* binding */ ListItem; },
/* harmony export */   "QI": function() { return /* binding */ UnorderedList; },
/* harmony export */   "aV": function() { return /* binding */ List; }
/* harmony export */ });
/* unused harmony exports useListStyles, ListIcon */
/* harmony import */ var _chakra_ui_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56877);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55227);
/* harmony import */ var _chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92495);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35059);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91639);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33179);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82504);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// src/list.tsx





var [ListStylesProvider, useListStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `ListStylesContext`,
  errorMessage: `useListStyles returned is 'undefined'. Seems you forgot to wrap the components in "<List />" `
});
var List = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(function List2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useMultiStyleConfig */ .jC)("List", props);
  const {
    children,
    styleType = "none",
    stylePosition,
    spacing,
    ...rest
  } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .omitThemingProps */ .Lr)(props);
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_5__/* .getValidChildren */ .W)(children);
  const selector = "& > *:not(style) ~ *:not(style)";
  const spacingStyle = spacing ? { [selector]: { mt: spacing } } : {};
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListStylesProvider, { value: styles, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_6__/* .chakra.ul */ .m.ul,
    {
      ref,
      listStyleType: styleType,
      listStylePosition: stylePosition,
      role: "list",
      __css: { ...styles.container, ...spacingStyle },
      ...rest,
      children: validChildren
    }
  ) });
});
List.displayName = "List";
var OrderedList = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)((props, ref) => {
  const { as, ...rest } = props;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(List, { ref, as: "ol", styleType: "decimal", marginStart: "1em", ...rest });
});
OrderedList.displayName = "OrderedList";
var UnorderedList = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(function UnorderedList2(props, ref) {
  const { as, ...rest } = props;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(List, { ref, as: "ul", styleType: "initial", marginStart: "1em", ...rest });
});
UnorderedList.displayName = "UnorderedList";
var ListItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(function ListItem2(props, ref) {
  const styles = useListStyles();
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_6__/* .chakra.li */ .m.li, { ref, ...props, __css: styles.item });
});
ListItem.displayName = "ListItem";
var ListIcon = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(function ListIcon2(props, ref) {
  const styles = useListStyles();
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .J, { ref, role: "presentation", ...props, __css: styles.icon });
});
ListIcon.displayName = "ListIcon";




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6556,4617,1191,5982,9059,9774,2888,179], function() { return __webpack_exec__(22871); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);